(() => {
  if (window.__htCardIngredients) return;
  window.__htCardIngredients = true;

  const SAFE = 8;
  const Z = '2147483000';

  const rootFromPanel = (panel) => {
    if (!panel) return null;
    if (panel._htRoot && document.contains(panel._htRoot)) return panel._htRoot;
    const id = panel.id;
    if (id) {
      const btn = document.querySelector('[data-ht-ing-open][aria-controls="' + id + '"]');
      if (btn) return btn.closest('[data-ht-ing]');
    }
    return panel.closest('[data-ht-ing]');
  };

  const resetPanelInline = (panel) => {
    panel.style.top = '';
    panel.style.left = '';
    panel.style.right = '';
    panel.style.bottom = '';
    panel.style.maxHeight = '';
    panel.style.width = '';
    panel.style.visibility = '';
    panel.style.position = '';
    panel.style.zIndex = '';
    const body = panel.querySelector('.ht-ing__panel-body');
    if (body) body.style.maxHeight = '';
  };

  const closeAll = (except) => {
    document.querySelectorAll('[data-ht-ing].is-open').forEach((root) => {
      if (except && root === except) return;
      close(root);
    });
  };

  const positionPanel = (btn, panel) => {
    panel.style.position = 'fixed';
    panel.style.zIndex = Z;
    panel.style.visibility = 'hidden';
    panel.style.top = '0';
    panel.style.left = '0';
    panel.style.right = 'auto';
    panel.style.bottom = 'auto';
    panel.style.width = '';
    panel.style.maxHeight = '';

    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const maxW = Math.min(280, vw - SAFE * 2);
    panel.style.width = maxW + 'px';

    const head = panel.querySelector('.ht-ing__panel-head');
    const body = panel.querySelector('.ht-ing__panel-body');
    if (body) body.style.maxHeight = '';

    const br = btn.getBoundingClientRect();
    const pr = panel.getBoundingClientRect();
    const headH = head ? head.getBoundingClientRect().height : 40;

    const spaceBelow = vh - br.bottom - SAFE;
    const spaceAbove = br.top - SAFE;
    // Prefer opening ABOVE the icon when there is room (avoids sitting under next card row)
    const preferBelow = !(spaceAbove >= 100 || spaceAbove >= spaceBelow);
    let top;
    let avail;
    if (preferBelow) {
      top = br.bottom + 6;
      avail = vh - top - SAFE;
    } else {
      avail = spaceAbove - 6;
      top = Math.max(SAFE, br.top - 6 - Math.min(pr.height, avail));
      avail = br.top - 6 - top;
    }
    // Taller panel (70vh); body scrolls via flex — do NOT set body maxHeight
    // (double max-height was clipping the last line while showing a useless scrollbar)
    const maxPanelH = Math.max(180, Math.min(avail, Math.floor(vh * 0.7)));
    panel.style.maxHeight = maxPanelH + 'px';
    if (body) {
      body.style.maxHeight = '';
      body.style.overflowY = 'auto';
      body.style.webkitOverflowScrolling = 'touch';
      body.style.pointerEvents = 'auto';
      body.style.touchAction = 'pan-y';
      if (!body.dataset.htScrollBound) {
        body.dataset.htScrollBound = '1';
        const stop = (e) => { e.stopPropagation(); };
        body.addEventListener('wheel', stop, { passive: true });
        body.addEventListener('touchmove', stop, { passive: true });
      }
    }

    const pr2 = panel.getBoundingClientRect();
    if (preferBelow) {
      top = br.bottom + 6;
      if (top + pr2.height > vh - SAFE) top = Math.max(SAFE, vh - SAFE - pr2.height);
    } else {
      top = br.top - 6 - pr2.height;
      if (top < SAFE) top = SAFE;
    }
    panel.style.top = Math.round(top) + 'px';
    panel.style.bottom = 'auto';

    let left = br.right - maxW;
    if (left < SAFE) left = SAFE;
    if (left + maxW > vw - SAFE) left = Math.max(SAFE, vw - SAFE - maxW);
    panel.style.left = Math.round(left) + 'px';
    panel.style.right = 'auto';
    panel.style.visibility = '';
  };

  const open = (root) => {
    closeAll(root);
    const btn = root.querySelector('[data-ht-ing-open]');
    let panel = root.querySelector('[data-ht-ing-panel]');
    if (!btn) return;
    // Panel may already be portaled to body from a prior open
    if (!panel && btn.getAttribute('aria-controls')) {
      panel = document.getElementById(btn.getAttribute('aria-controls'));
    }
    if (!panel) return;

    panel._htRoot = root;
    root.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    // Portal to body so card overflow/transform cannot clip fixed panel
    if (panel.parentElement !== document.body) {
      document.body.appendChild(panel);
    }
    panel.setAttribute('data-ht-ing-ported', 'true');
    positionPanel(btn, panel);
    const closeBtn = panel.querySelector('[data-ht-ing-close]');
    (closeBtn || panel).focus({ preventScroll: true });
  };

  const close = (root) => {
    if (!root) return;
    const btn = root.querySelector('[data-ht-ing-open]');
    let panel = root.querySelector('[data-ht-ing-panel]');
    if (!panel && btn && btn.getAttribute('aria-controls')) {
      panel = document.getElementById(btn.getAttribute('aria-controls'));
    }
    if (!btn || !panel) return;
    root.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
    resetPanelInline(panel);
    panel.removeAttribute('data-ht-ing-ported');
    // Return panel to card root for a11y/DOM locality
    if (panel.parentElement !== root) {
      root.appendChild(panel);
    }
    panel._htRoot = null;
    btn.focus({ preventScroll: true });
  };

  const repositions = () => {
    document.querySelectorAll('[data-ht-ing].is-open').forEach((root) => {
      const btn = root.querySelector('[data-ht-ing-open]');
      let panel = root.querySelector('[data-ht-ing-panel]');
      if (!panel && btn && btn.getAttribute('aria-controls')) {
        panel = document.getElementById(btn.getAttribute('aria-controls'));
      }
      if (btn && panel && !panel.hidden) positionPanel(btn, panel);
    });
  };

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-ht-ing-open]');
    if (openBtn) {
      e.preventDefault();
      e.stopPropagation();
      const root = openBtn.closest('[data-ht-ing]');
      if (!root) return;
      if (root.classList.contains('is-open')) close(root);
      else open(root);
      return;
    }
    const closeBtn = e.target.closest('[data-ht-ing-close]');
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      const panel = closeBtn.closest('[data-ht-ing-panel]');
      const root = rootFromPanel(panel);
      if (root) close(root);
      return;
    }
    // Click outside: ignore clicks on a portaled panel
    if (e.target.closest('[data-ht-ing]') || e.target.closest('[data-ht-ing-panel]')) return;
    closeAll();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const openRoot = document.querySelector('[data-ht-ing].is-open');
    if (openRoot) {
      e.preventDefault();
      close(openRoot);
    }
  });

  window.addEventListener('resize', repositions, { passive: true });
  window.addEventListener('scroll', repositions, { passive: true, capture: true });

  // Ensure all panels start closed (CSS display:flex must not leave them visible)
  document.querySelectorAll('[data-ht-ing-panel]').forEach((panel) => {
    panel.hidden = true;
    const root = panel.closest('[data-ht-ing]') || (panel._htRoot || null);
    if (root) root.classList.remove('is-open');
    const btn = root && root.querySelector('[data-ht-ing-open]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  });

})();
